// eslint-disable-next-line import/no-anonymous-default-export
export default () => {
  return (
    <svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M4.95032 7.00123L0.000320435 2.05123L1.41432 0.637234L7.77832 7.00123L1.41432 13.3652L0.000320435 11.9512L4.95032 7.00123Z" fill="#181833"/>
    </svg>
  )
}